<p>pricing-modif-editor works!</p>
